import ProcessAlarmModal from './process-alarm-modal.vue'
export default ProcessAlarmModal
